/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'

interface UiFormLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
    isRequired?: boolean
}

const UiFormLabel = React.forwardRef<HTMLLabelElement, UiFormLabelProps>(
    ({ children, isRequired, className, ...rest }, ref) => {
        return (
            <label
                ref={ref}
                className={clsx(
                    'UiFormLabel block text-sm font-medium text-gray-900 dark:text-gray-100',
                    className
                )}
                {...rest}
            >
                <span>{children}</span>
                {isRequired && <em className="ml-1 text-red-500">*</em>}
            </label>
        )
    }
)

UiFormLabel.displayName = 'UiFormLabel'

export default UiFormLabel
